import React, { createContext, useContext } from "react";

export const ResumeContext = createContext(null);

export const useResumeContext = () => {
  return useContext(ResumeContext);
};